"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.driverEarningsDLogFrom = exports.driverEarningsDLogDeserialize = void 0;
const moment_1 = __importDefault(require("moment"));
const User_1 = require("../controllers/User");
const expect_1 = __importDefault(require("../util/expect"));
const unwrap_1 = __importDefault(require("../util/unwrap"));
const BaseUser_1 = require("./BaseUser");
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const AuthType_1 = require("./firebase/AuthType");
function driverEarningsDLogDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value, 'driver earnings d log');
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        value: (0, unwrap_1.default)(object.value, deserializeNumber_1.deserializeNumber),
        eventTimestampMs: (0, deserializeNumber_1.deserializeNumber)(object.eventTimestampMs),
        authType: (0, AuthType_1.authTypeDeserialize)(object.authType),
        uid: (0, unwrap_1.default)(object.uid, deserializeString_1.deserializeString),
        userCasualName: (0, unwrap_1.default)(object.userCasualName, deserializeString_1.deserializeString),
        tripId: (0, deserializeString_1.deserializeString)(object.tripId),
    };
}
exports.driverEarningsDLogDeserialize = driverEarningsDLogDeserialize;
async function driverEarningsDLogFrom(value, context, tripId, database) {
    var _a, _b;
    return {
        value,
        eventTimestampMs: (0, moment_1.default)(context.timestamp).valueOf(),
        authType: (0, expect_1.default)(context.authType),
        uid: (_a = context.auth) === null || _a === void 0 ? void 0 : _a.uid,
        userCasualName: ((_b = context.auth) === null || _b === void 0 ? void 0 : _b.uid) ? (0, BaseUser_1.baseUserCasualName)(await (0, User_1.userRead)(context.auth.uid, database)) : undefined,
        tripId,
    };
}
exports.driverEarningsDLogFrom = driverEarningsDLogFrom;
